import {GameRandom, Inject, ModelEvents, Singleton} from "@denishussar/html5-game-engine";

export enum CellStateEnum {
    open = "open",
    close = "close",
}

export class CellModel {
    public state: CellStateEnum = CellStateEnum.close;

    constructor(public index: number) {
    }
}

@Singleton
export class LockCellModel {
    public cells = new Array<CellModel>();
    public cellsCount: number = 13;
    public cellsCountOpened: [number, number] = [3, 5];
    public complete: boolean = false;

    constructor(
        @Inject private _$random: GameRandom,
        @Inject private _$modelEvents: ModelEvents
    ) {
        for (let i = 0; i < 13; i++) {
            this.cells.push(new CellModel(i));
        }
    }
}
